export enum DeepfakeJobStatusEnumEnum {
    PENDING = 'pending',
    COMPLETED = 'completed',
    FAILED = 'failed',
}
